var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wf-ideabook-banner" }, [
    _c("img", {
      staticClass: "background-image",
      attrs: {
        src: _vm.ideabookdetail.pages.ideabookBackgroundImage.replace("~", ""),
        alt: "IdeabookBackgroundImage"
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "wf-ideabook-banner-content" }, [
        _c(
          "div",
          {
            staticClass: "wf-ideabook-banner-content-section",
            style: {
              backgroundColor: _vm.ideabookdetail.pages.ideabookBackgroundColor
            }
          },
          [
            _c("div", { staticClass: "p-5" }, [
              _c("h1", { staticClass: "display-3 text-white" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.ideabookdetail.pages.ideabookTitle) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.ideabookdetail.pages.ideabookPublicationYear) +
                    " / Issue\n            " +
                    _vm._s(_vm.ideabookdetail.pages.ideabookIssueNumber) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.ideabookdetail.pages.ideabookDescription) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              !_vm.ideabookdetail.pages.ideabookHideAddToCartButton
                ? _c("div", { staticClass: "py-3" }, [
                    _c(
                      "div",
                      { staticClass: "vue-wf-ecommerce-ideabook-state" },
                      [
                        _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.ideabookdetail.parent
                                  .ideabookFolderAddToBasketText
                              ) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("wf-add-to-cart-idea-book-button", {
                          attrs: {
                            "selling-style-number":
                              _vm.ideabookdetail.pages.ideabookStyleNumber,
                            "color-number":
                              _vm.ideabookdetail.pages.ideabookColorNumber,
                            "vehicle-id":
                              _vm.ideabookdetail.pages.ideabookVehicleId,
                            "button-text": "Add to basket",
                            "trusted-user": _vm.ideabookdetail.isTrustedDetail
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "py-3" }, [
                _c("p", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.ideabookdetail.parent.ideabookFolderDownloadPdfText
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary justify-content-start",
                    attrs: {
                      href: _vm.ideabookdetail.pages.ideabookPdf.replace(
                        "~",
                        ""
                      ),
                      target: "_blank"
                    }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-glyph--ko-btn-download"
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v("\n                Download PDF\n              ")
                    ])
                  ]
                )
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wf-ideabook-banner-content-section" }, [
          _c("img", {
            staticClass: "w-100 img-fluid",
            attrs: {
              src: _vm.ideabookdetail.pages.ideabookCoverImage.replace("~", ""),
              alt: "IdeabookBackgroundImage"
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }